import LoginSSO from './LoginSSO';

export default LoginSSO;
